import { ref } from 'vue';

export function useDevToolsDetector() {
  // Ignorer en mode développement local
  if (
    window.location.hostname.includes('localhost') ||
    window.location.href.includes('devtool')
  ) {
    return {
      isDevToolsOpen: ref(false),
      startMonitoring: () => {},
      stopMonitoring: () => {}
    };
  }

  const isDevToolsOpen = ref(false);
  let checkInterval = null;

  // On conserve une copie isolée de console.log avant qu'elle ne soit écrasée globalement
  const originalLog = console.originalLog || console.log;

  const element = new Image();
  Object.defineProperty(element, 'id', {
    get() {
      // Ce getter s'exécute quand la console essaie d'afficher l'objet 'element'
      isDevToolsOpen.value = true;
      return '';
    }
  });

  const checkByDimensions = () => {
    // Évite les mobiles pour limiter les faux positifs liés aux claviers virtuels
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouch) return false;

    const threshold = 160;
    return (
      window.outerWidth - window.innerWidth > threshold ||
      window.outerHeight - window.innerHeight > threshold
    );
  };

  const startMonitoring = (onOpen, onClose) => {
    // Fréquence réduite à 1000ms pour éviter de surcharger le processeur des appareils lents
    checkInterval = setInterval(() => {
      const wasOpen = isDevToolsOpen.value;
      isDevToolsOpen.value = false;

      // 1. Détection via l'inspection console
      originalLog(element);
      if (console.clear) console.clear();

      // 2. Détection par écart de taille (Desktop uniquement)
      if (checkByDimensions()) {
        isDevToolsOpen.value = true;
      }

      // Gestion des callbacks
      if (isDevToolsOpen.value && !wasOpen && onOpen) onOpen();
      if (!isDevToolsOpen.value && wasOpen && onClose) onClose();
    }, 1000);
  };

  const stopMonitoring = () => {
    if (checkInterval) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
  };

  return { isDevToolsOpen, startMonitoring, stopMonitoring };
}
